import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('@mintdata/mint-kit/impl/properties/components/inputLabel/InputLabel.less');
const cx = classnames.bind(styles);

export interface ILabelProps
{
    text:string;
    isCentered?:boolean;
    className?:string;
    style?:React.CSSProperties;
}

export class InputLabel extends React.Component<ILabelProps>
{
    public render():JSX.Element
    {
        const {text, isCentered = false, className = '', style = {}} = this.props;

        return (
            <span
                className={cx(styles.base, {isCentered}, className)}
                style={style}
            >
				{text}
			</span>
        );
    }
}

